import { Component, Input, OnInit } from '@angular/core';
import { Messagetype } from 'src/app/Shared/model/model/enum';
import { HttpStatusCode, ResponseModel } from 'src/app/Shared/model/response.model';
import { ApiDataService } from 'src/app/Shared/services/apidata.service';
import { AppService } from 'src/app/Shared/services/app.service';
import { GetSetService } from 'src/app/Shared/services/getset.serverce';
import { ToastService } from 'src/app/Shared/services/toast.service';
import { IProduct } from '../Shared/model/model/product.model';
import { IUserInfo } from '../Shared/model/userinfo.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-control',
  templateUrl: 'control.component.html'
})
export class ControlComponent implements OnInit {

  userInfo?: IUserInfo
  @Input() productDetails!: IProduct;
  @Input() fromCart: boolean = false;

  public isUserLoggedIn = this.getsetService.isloggedInUser();

  constructor(
    private getsetService: GetSetService,
    private appservice: AppService,
    private apidata: ApiDataService,
    private toast: ToastService,
    private router: Router,
  ) {

  }


  ngOnInit(): void {

  }

  addtocart(): void {
        const isUserLogin = this.getsetService.isloggedInUser();
    const cartItem = {
      id: 0,
      // productId: this.productDetails?.id,
      productId: this.fromCart ? this.productDetails?.productId : this.productDetails?.id,

      // quantity: this.productDetails?.quantity,
      quantity: this.productDetails?.quantity === 0 ? 1 : this.productDetails?.quantity,
      // size:this.productDetails?.size === 0 ?
			// 				((this.productDetails?.typeId === 3 || this.productDetails?.productType === 4 ||
			// 					this.productDetails?.productType === 6 || this.productDetails?.productType === 7) ? 1 : 2)
			// 				: this.productDetails?.size,

    };


    if (isUserLogin) {
        const url = `Cart/AddToCart`;
        this.apidata
          .postData(url, cartItem)
          .subscribe((response: ResponseModel<any>) => {
            if (response.status === HttpStatusCode.OK) {
//               const message = this.productDetails.quantity === 1
//   ? 'Item successfully added to cart.'
//   : 'Cart message removed.';

// this.toast.showToast(Messagetype.sucess, 'info', message);

              if(this.productDetails.quantity === 0 ){
              this.toast.showToast(Messagetype.sucess, 'info', 'Item successfully added to cart.');
              }
              this.appservice.setCart(true);
              if (this.productDetails) {
                this.productDetails.isInCart = true;
              }

            } else if (
              response.status === HttpStatusCode.INTERNAL_SERVER_ERROR
            ) {

              this.toast.showToast(Messagetype.fail, 'info', `${response.statusMessage}`);

            } else {
              this.toast.showToast(Messagetype.fail, 'info', `${response.statusMessage}`);
            }
          });
      // } else {

      //   this.toast.showToast(Messagetype.fail, 'info', `Service not available in this area.`);
      // }

    } else {
      this.router.navigateByUrl(`login`);
    }

  }

  increment() {
    if (this.productDetails) {
      this.productDetails.quantity = (this.productDetails) ? this.productDetails?.quantity + 1 : 1;
      this.addtocart();
    }
  }

  decrement() {
    if (this.productDetails.quantity > 1) {
      if (this.productDetails.quantity === 0)  {
      } else if(this.productDetails.quantity !== 1 )  {
        this.productDetails.quantity = this.productDetails?.quantity - 1;
        this.addtocart();
      }
    }else{
      this.toast.showToast(
        Messagetype.fail,
        'Info',
        `Product Quantity Should be one`
      );
    }
  }


// Remove to cart
  removetocart(): void {
    const isUserLogin = this.getsetService.isloggedInUser();
    const cartItem = {
      id: 0,
      productTypeId: this.productDetails?.productType,
      productId: this.productDetails?.id,
      amount: this.productDetails?.mrp
    };

    if (isUserLogin) {
      if (this.getsetService.getArea()?.isServiceAvailable) {
        const url = `Cart/RemoveCart?ProductId=${this.productDetails?.id}`;
        this.apidata
          .getData(url)
          .subscribe((response: ResponseModel<any>) => {
            if (response.status === HttpStatusCode.OK) {
              this.appservice.setCart(true);
              if (this.productDetails) {
                this.productDetails.isInCart = false;
              }
            } else if (
              response.status === HttpStatusCode.INTERNAL_SERVER_ERROR
            ) {
            } else {
            }
          });
      } else {
      }

    } else {
    }
  }
}
